export default __webpack_public_path__ + "static/media/field-operations-launch-kit.4a28f811.svg";